(function () {
    // Fallback, falls CSS.escape im Browser fehlt
    if (typeof window.CSS === 'undefined') window.CSS = {};
    if (typeof window.CSS.escape !== 'function') {
        window.CSS.escape = function (sel) { return String(sel).replace(/[^a-zA-Z0-9_\-]/g, '\\$&'); };
    }

    function getPanel(root, panelId) {
        return root.querySelector('#' + CSS.escape(panelId)) || document.getElementById(panelId);
    }

    function showPanel(panel, expanded) {
        panel.hidden = !expanded;
        if (expanded) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        if (expanded && panel.classList.contains('hidden')) panel.classList.remove('hidden');
        panel.classList.toggle('is-open', expanded);
        if (expanded && panel.style.display === 'none') panel.style.removeProperty('display');
    }

    function setExpanded(root, btn, expanded) {
        const panelId = btn.getAttribute('aria-controls');
        const panel = getPanel(root, panelId);
        btn.setAttribute('aria-expanded', String(expanded));
        if (panel) showPanel(panel, expanded);
    }

    function initSection(root) {
        if (!root || root.__faqInit) return; // Doppelt-Init vermeiden
        root.__faqInit = true;

        const singleOpen = root.getAttribute('data-single-open') === 'true';

        root.querySelectorAll('.faq-media__toggle').forEach((btn) => {
            const li = btn.closest('.faq-media__item');
            const openByDefault = li && li.getAttribute('data-open-by-default') === 'true';
            setExpanded(root, btn, openByDefault);
        });

        root.addEventListener('click', (e) => {
            const btn = e.target.closest('.faq-media__toggle');
            if (!btn || !root.contains(btn)) return;
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            if (singleOpen && !isOpen) {
                root.querySelectorAll('.faq-media__toggle[aria-expanded="true"]').forEach((other) => {
                    if (other !== btn) setExpanded(root, other, false);
                });
            }
            setExpanded(root, btn, !isOpen);
        });
        root.addEventListener('keydown', (e) => {
            if ((e.key === ' ' || e.key === 'Enter')) {
                const btn = e.target.closest('.faq-media__toggle');
                if (!btn || !root.contains(btn)) return;
                e.preventDefault();
                btn.click();
            }
        });

        function openFromHash() {
            const hash = window.location.hash.slice(1);
            if (!hash) return;
            const target = root.querySelector('#' + CSS.escape(hash));
            if (!target) return;
            let btn;
            if (target.classList.contains('faq-media__panel')) {
                btn = root.querySelector('[aria-controls="' + hash + '"]');
            } else if (target.classList.contains('faq-media__title')) {
                const id = target.getAttribute('id'); // q-<sectionId>-<blockId>
                const panelId = 'a-' + id.replace(/^q-/, '');
                btn = root.querySelector('[aria-controls="' + panelId + '"]');
            }
            if (btn) {
                if (singleOpen) root.querySelectorAll('.faq-media__toggle[aria-expanded="true"]').forEach((o)=>setExpanded(root,o,false));
                setExpanded(root, btn, true);
                try { btn.focus({ preventScroll: true }); } catch (_) {}
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        window.addEventListener('hashchange', openFromHash);
        openFromHash();
    }

    function initAll() {
        document.querySelectorAll('.faq-media').forEach(initSection);
    }

    // DOM bereit
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
        const root = e.target.querySelector('.faq-media');
        if (root) initSection(root);
    });
    document.addEventListener('shopify:section:select', function (e) {
        const root = e.target.querySelector('.faq-media');
        if (root) initSection(root);
    });
})();
